import React, {Component} from 'react';
import {gpn} from "../GPN"
import config from "../config";
import axios from "axios";
import Button from "../sections/MUI/Button";
import Field from "../sections/MUI/Field";
import File from "../sections/MUI/File";
import Cascader from 'rc-cascader';
import {toast} from "react-toastify";
import Select from "../sections/MUI/Select";

class Categories extends Component {

    state = {
        boxAdd: false,
        categories: {
            all: [],
            categories: null,
            cascaderCategories: []
        },

        title: "",
        image: null,
        description: "",
        parent: [],

        editId: ""
    };


    componentDidMount() {
        config.scrollTop();
        this.getCategories();
    }


    getCategories() {
        axios.get(`${config.api}/admin/categories?token=${config.token}`)
            .then(r => {
                this.setState({
                    categories: r.data
                });
            })
            .catch(err => {
                config.handleError(err)
            });
    }

    renderChildrenCategories(children) {
        return children ? children.length > 0 ?
            <div className="sub-categories">
                {
                    children.map((scat, i) =>
                        <div
                            key={"scat" + i} className="row">
                            <div className="col-auto">
                                <div
                                    className="title"
                                    onClick={() => this.props.navigate(`/category/${scat._id}`)}>-&nbsp;{scat.title}</div>
                                <div>
                                    {this.renderChildrenCategories(scat.children)}
                                </div>
                            </div>

                        </div>
                    )
                }
            </div> : null : null;

    }

    submit() {
        const {title, image, description, parent} = this.state;
        if (title !== "" && image && description !== "") {
            let params = new FormData();
            params.append("title", title);
            params.append('image', image);
            params.append("parent", parent);
            params.append("meta", JSON.stringify({
                description
            }));
            axios.post(`${config.api}/admin/category?token=${config.token}`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(r => {
                    toast.success("با موفقیت ثبت شد.");
                    this.setState({
                        categories: {
                            all: [],
                            categories: [],
                            cascaderCategories: []
                        },
                        title: '',
                        image: null,
                        description: ""
                    });
                    this.getCategories();
                })
                .catch(err => {
                    config.handleError(err);
                });

        } else {
            toast.error("همه فیلد ها را کامل کنید")
        }
    }

    handleParentCategoryChange(selected) {
        let arr = selected.includes(",") ? selected.split(',') : selected;
        const parent = arr[arr.length - 1];
        this.setState({
            parent
        });
    }

    render() {
        const {boxAdd, title, image, description, parent, categories} = this.state;
        return (
            <div className="categories">

                <div className="row">
                    <div className="col-md-5">
                        <Button submit={false} onClick={() => this.setState({boxAdd: !boxAdd})} icon="plus">ثبت
                            کردن</Button>
                    </div>
                </div>

                {boxAdd ?
                    <div className="new">
                        <div className="row">
                            <div className="col-md-6">
                                <Field name="title"
                                       value={title}
                                       label="عنوان"
                                       maxLength={255}
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-md-6">
                                <File
                                    value={image}
                                    label="عکس"
                                    name="image"
                                    multiple={false}
                                    accept="image/*"
                                    onChange={(name, value) => this.setState({image: value})}/>
                            </div>

                            <div className="col-md-6">

                                <Select value={parent}
                                        label="دسته بندی مادر"
                                        placeholder="انتخاب کنید"
                                        name="parent"
                                        simple
                                        onChange={(name, value) => this.setState({parent: value})}
                                        options={categories.all.map((c, i) => {
                                            return {t: c.title, v: c.id}
                                        })}/>
                            </div>

                            <div className="col-md-6">
                                <Field name="description"
                                       value={description}
                                       label="توضیحات متا"
                                       type="textarea"
                                       row={3}
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-md-5">
                                <Button submit={false} icon="check"
                                        onClick={() => this.submit()}>ثبت کردن</Button>
                            </div>
                        </div>
                    </div>
                    : null}

                <div className="list">
                    {
                        categories.categories ?
                            categories.categories.length > 0 ?
                                categories.categories.map((c, i) =>
                                    <div id={"c" + i} className="category" key={"c__" + i}>

                                        <div className="title"
                                             onClick={() => this.props.navigate(`/category/${c._id}`)}>{c.title}</div>
                                        {
                                            c.children ? this.renderChildrenCategories(c.children)
                                                : null
                                        }

                                    </div>
                                )
                                : <div>لیست دسته بندی خالی است</div>
                            : null
                    }
                </div>

            </div>
        );
    }
}

export default gpn(Categories);